<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="90%"
    top="15px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    destroy-on-close
    lock-scroll
    @open="open"
    @close="clearAll"
  >
    <template #title>
      {{ headerText }}申请发货信息(<span style="color:#FF0000;">{{ isOriginOrderNumber ? currentClickData.oldDeliveryNum : currentClickData.deliveryNum }}</span>)
    </template>
    <div v-loading="isDialogLoading">
      <!-- <div style="margin-bottom: 10px; font-weight: 800; font-size: 18px;">
        产品信息
      </div> -->
      <el-button v-if="isEdit" type="primary" style="margin: 5px 0" @click="removeProduct">
        删除勾选的产品
      </el-button>
      <!-- 有实物产品 -->
      <h4 class="contain-physical-title-style">
        有实物产品
      </h4>
      <el-table
        :data="containPhysicalDataList"
        style="width: 100%"
        border
        show-summary
        sum-text="合计"
        :summary-method="getTotal"
        :row-class-name="setCheckBoxHiddenOrVisible"
        @selection-change="selectionChange"
      >
        <el-table-column v-if="isEdit" align="left" type="selection" />
        <el-table-column width="50" label="序号" align="left" type="index" />
        <el-table-column width="150" label="合同号" align="left" prop="contractNum" />
        <el-table-column v-if="showOrderNumberColumn" width="150" label="ERP订单号" align="left" prop="orderNumber" />
        <el-table-column
          v-if="!isBGContract"
          prop="itemIndex"
          label="Order Line Id"
          align="left"
          min-width="120"
        />
        <el-table-column min-width="220" label="物品代码" align="left" prop="materialNumber" />
        <el-table-column min-width="220" label="物品名称" align="left" prop="productName" />
        <el-table-column v-if="isApprove" min-width="150" label="ERP订单行号" align="left" prop="lineNum" />
        <el-table-column width="70" label="数量" align="left" prop="productNum" />
        <el-table-column width="120" label="实际结算单价" align="right" prop="productPriceSigle" header-align="left">
          <template v-slot="{row}">
            {{ row.productPriceSigle && Number(row.productPriceSigle).toFixed(2) }}
          </template>
        </el-table-column>
        <el-table-column width="120" label="实际结算金额" align="right" prop="amountSum" header-align="left">
          <template v-slot="{row}">
            {{ (row.amountSum ? Number(row.amountSum) : 0).toFixed(2) }}
          </template>
        </el-table-column>
        <el-table-column width="120" label="客户期望发货日" align="left" prop="expectationSendTime">
          <template v-slot="{row}">
            {{ row.expectationSendTime && DateToStr(new Date(row.expectationSendTime)) }}
          </template>
        </el-table-column>
        <el-table-column width="120" label="约定交付日期" align="left" prop="agreedDate">
          <template v-slot="{row}">
            {{ row.agreedDate && DateToStr(new Date(row.agreedDate)) }}
          </template>
        </el-table-column>
        <el-table-column width="120" label="整改后交期" align="left" prop="deliveryDateAfterRectification">
          <template v-slot="{row}">
            {{ row.deliveryDateAfterRectification && DateToStr(new Date(row.deliveryDateAfterRectification)) }}
          </template>
        </el-table-column>
        <el-table-column v-if="isApprove && approveRole==='orderTaker'" width="150" label="属性号" align="left" prop="propertyNum">
          <template v-slot="{row}">
            <el-input v-if="row.index!=='小计' && !row.propertyNum" v-model="propertyNumInfos[row.id]" />
            <span v-else>{{ row.propertyNum }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="physicalFlag"
          label="是否实物"
          align="left"
          width="80"
        >
          <template v-slot="{row}">
            {{ row.physicalFlag ? '是' : '否' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="batteryFlag"
          label="是否带电池"
          align="left"
          width="100"
        >
          <template v-slot="{row}">
            {{ row.batteryFlag ? '是' : '否' }}
          </template>
        </el-table-column>
        <el-table-column width="100" label="预估体积(m³)" align="left" prop="volume" />
        <el-table-column width="100" label="预估重量(kg)" align="left" prop="grossWeight" />
        <el-table-column width="70" label="账期" align="left" prop="accountPeriod" />
        <el-table-column width="120" label="仓位" align="left" prop="warehouse" />
      </el-table>
      <!-- 商务订单员审核自动过单，关务待审核和已审核展示 -->
      <template v-if="distriMoneyList.length">
        <div style="margin: 20px 0; font-weight: 800; font-size: 18px;">
          分配金额
        </div>
        <el-table :data="distriMoneyList" border>
          <el-table-column label="序号" type="index" align="left" width="50" />
          <el-table-column label="合同号" prop="contractNum" align="left" />
          <el-table-column label="实际结算金额" prop="actualSettlementAmount" align="left">
            <template v-slot="{row}">
              {{ Number(row.actualSettlementAmount).toFixed(2) }}
            </template>
          </el-table-column>
          <el-table-column label="已分配金额" prop="assignAll" align="left">
            <template v-slot="{row}">
              {{ Number(row.assignAll).toFixed(2) }}
            </template>
          </el-table-column>
          <el-table-column label="预付款金额" prop="advancePaymentAmount" align="left">
            <template v-slot="{row}">
              {{ Number(row.advancePaymentAmount).toFixed(2) }}
            </template>
          </el-table-column>
          <el-table-column label="预付款比例" prop="prepaymentRatioNum" align="left">
            <template v-slot="{row}">
              {{ (Number(row.prepaymentRatioNum) * 100).toFixed(2) }}%
            </template>
          </el-table-column>
          <el-table-column label="已发货金额" prop="shippedAmount" align="left">
            <template v-slot="{row}">
              {{ Number(row.shippedAmount).toFixed(2) }}
            </template>
          </el-table-column>
          <el-table-column label="流程中单据金额" prop="processAmount" align="left">
            <template v-slot="{row}">
              {{ Number(row.processAmount).toFixed(2) }}
            </template>
          </el-table-column>
          <el-table-column label="本次发货金额" prop="nowShipmentAmount" align="left">
            <template v-slot="{row}">
              {{ Number(row.nowShipmentAmount).toFixed(2) }}
            </template>
          </el-table-column>
          <el-table-column label="验证金额差异" prop="amountDifference" align="left">
            <template v-slot="{row}">
              <span :style="Number(row.amountDifference)<0 && {color:'red'}">{{ Number(row.amountDifference).toFixed(2) }}</span>
            </template>
          </el-table-column>
        </el-table>
        <div>说明：验证金额差异公式=（已分配金额-预付款金额）-（已发货金额+流程中单据金额+本次发货金额）*（1-预付款比例）</div>
      </template>

      <!-- 无实物产品 -->
      <h4 class="not-contain-physical-title-style">
        无实物产品
      </h4>
      <el-table
        :data="notContainPhysicalDataList"
        style="width: 100%"
        border
        show-summary
        sum-text="合计"
        :summary-method="getTotal"
        :row-class-name="setCheckBoxHiddenOrVisible"
        @selection-change="notSelectionChange"
      >
        <el-table-column v-if="isEdit" align="left" type="selection" />
        <el-table-column width="50" label="序号" align="left" type="index" />
        <el-table-column width="150" label="合同号" align="left" prop="contractNum" />
        <el-table-column v-if="showOrderNumberColumn" width="150" label="ERP订单号" align="left" prop="orderNumber" />
        <el-table-column
          v-if="!isBGContract"
          prop="itemIndex"
          label="Order Line Id"
          align="left"
          min-width="120"
        />
        <el-table-column min-width="220" label="物品代码" align="left" prop="materialNumber" />
        <el-table-column min-width="220" label="物品名称" align="left" prop="productName" />
        <el-table-column v-if="isApprove" min-width="150" label="ERP订单行号" align="left" prop="lineNum" />
        <el-table-column width="70" label="数量" align="left" prop="productNum" />
        <el-table-column width="120" label="实际结算单价" align="right" prop="productPriceSigle" header-align="left">
          <template v-slot="{row}">
            {{ row.productPriceSigle && Number(row.productPriceSigle).toFixed(2) }}
          </template>
        </el-table-column>
        <el-table-column width="120" label="实际结算金额" align="right" prop="amountSum" header-align="left">
          <template v-slot="{row}">
            {{ (row.amountSum ? Number(row.amountSum) : 0).toFixed(2) }}
          </template>
        </el-table-column>
        <el-table-column width="120" label="客户期望发货日" align="left" prop="expectationSendTime">
          <template v-slot="{row}">
            {{ row.expectationSendTime && DateToStr(new Date(row.expectationSendTime)) }}
          </template>
        </el-table-column>
        <el-table-column width="120" label="约定交付日期" align="left" prop="agreedDate">
          <template v-slot="{row}">
            {{ row.agreedDate && DateToStr(new Date(row.agreedDate)) }}
          </template>
        </el-table-column>
        <el-table-column width="120" label="整改后交期" align="left" prop="deliveryDateAfterRectification">
          <template v-slot="{row}">
            {{ row.deliveryDateAfterRectification && DateToStr(new Date(row.deliveryDateAfterRectification)) }}
          </template>
        </el-table-column>
        <el-table-column v-if="isApprove && approveRole==='orderTaker'" width="150" label="属性号" align="left" prop="propertyNum">
          <template v-slot="{row}">
            <el-input v-if="row.index!=='小计' && !row.propertyNum" v-model="propertyNumInfos[row.id]" />
            <span v-else>{{ row.propertyNum }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="physicalFlag"
          label="是否实物"
          align="left"
          width="80"
        >
          <template v-slot="{row}">
            {{ row.physicalFlag ? '是' : '否' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="batteryFlag"
          label="是否带电池"
          align="left"
          width="90"
        >
          <template v-slot="{row}">
            {{ row.batteryFlag ? '是' : '否' }}
          </template>
        </el-table-column>
        <!-- <el-table-column width="70" label="预估体积(m³)" align="left" prop="volume" /> -->
        <!-- <el-table-column width="70" label="预估重量(kg)" align="left" prop="grossWeight" /> -->
        <el-table-column width="70" label="账期" align="left" prop="accountPeriod" />
        <el-table-column width="120" label="仓位" align="left" prop="warehouse" />
        <!-- <template v-if="contractType =='国际分销下单'"> -->
        <el-table-column width="120" label="服务备注" align="left" prop="serviceDesc" />
        <!-- </template> -->
      </el-table>
      <!-- 总计 -->
      <div class="summary-row el-table__footer">
        <table>
          <tfoot>
            <tr>
              <td>合计</td>
              <td>{{ Number(totalAllQuantity).toFixed(2) }}</td>
              <td>{{ Number(totalAllAmountSum).toFixed(2) }}</td>
            </tr>
          </tfoot>
        </table>
      </div>
      <template v-if="isApprove && approveRole === 'orderTaker'">
        <div style="margin: 20px 0; font-weight: 800; font-size: 18px;">
          分配金额
        </div>
        <el-table :data="allocatedDetail" border>
          <el-table-column label="序号" type="index" align="left" width="50" />
          <el-table-column label="合同号" prop="contractNum" align="left" />
          <el-table-column label="实际结算金额" prop="actualSettlementAmount" align="right" header-align="left">
            <template v-slot="{row}">
              {{ Number(row.actualSettlementAmount).toFixed(2) }}
            </template>
          </el-table-column>
          <el-table-column label="已分配金额" prop="assignAll" align="right" header-align="left">
            <template v-slot="{row}">
              {{ Number(row.assignAll).toFixed(2) }}
            </template>
          </el-table-column>
          <el-table-column label="预付款金额" prop="advancePaymentAmount" align="right" header-align="left">
            <template v-slot="{row}">
              {{ Number(row.advancePaymentAmount).toFixed(2) }}
            </template>
          </el-table-column>
          <el-table-column label="预付款比例" prop="prepaymentRatioNum" align="right" header-align="left">
            <template v-slot="{row}">
              {{ (Number(row.prepaymentRatioNum) * 100).toFixed(2) }}%
            </template>
          </el-table-column>
          <el-table-column label="已发货金额" prop="shippedAmount" align="right" header-align="left">
            <template v-slot="{row}">
              {{ Number(row.shippedAmount).toFixed(2) }}
            </template>
          </el-table-column>
          <el-table-column label="流程中单据金额" prop="processAmount" align="right" header-align="left">
            <template v-slot="{row}">
              {{ Number(row.processAmount).toFixed(2) }}
            </template>
          </el-table-column>
          <el-table-column label="本次发货金额" prop="nowShipmentAmount" align="right" header-align="left">
            <template v-slot="{row}">
              {{ Number(row.nowShipmentAmount).toFixed(2) }}
            </template>
          </el-table-column>
          <el-table-column label="验证金额差异" prop="amountDifference" align="right" header-align="left">
            <template v-slot="{row}">
              <span :style="Number(row.amountDifference)<0 && {color:'red'}">{{ Number(row.amountDifference).toFixed(2) }}</span>
            </template>
          </el-table-column>
        </el-table>
        <div>说明：验证金额差异公式=（已分配金额-预付款金额）-（已发货金额+流程中单据金额+本次发货金额）*（1-预付款比例）</div>
      </template>
      <!-- 表单信息 -->
      <el-form ref="dialogForm" :model="dialogForm" :rules="rules" label-width="100px" :validate-on-rule-change="false">
        <div style="margin: 20px 0; font-weight: 800; font-size: 18px;">
          地址信息
        </div>
        <el-row>
          <el-col>
            <el-col :span="10">
              <el-form-item prop="receiptAddressId" label="收货地址:">
                <span v-if="isDetail || isApprove">{{ addressInfos[dialogForm.receiptAddressId] }}</span>
                <el-select
                  v-else
                  v-model="dialogForm.receiptAddressId"
                  class="addressSelect"
                  placeholder="请选择收货地址"
                  clearable
                >
                  <el-option v-for="option in deliveryAddressSelectList" :key="option.dictValue" :label="option.dictLabel" :value="option.dictValue" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="批次:">
                <span>{{ batchNum }}</span>
              </el-form-item>
            </el-col>
          </el-col>
          <el-col />
          <el-col />
        </el-row>
        <div style="margin: 20px 0; font-weight: 800; font-size: 18px;">
          {{ isBGContract?'海外备件仓地址:':'货代信息' }}
        </div>
        <el-row>
          <el-col :span="10">
            <el-form-item :label="isBGContract?'仓库名称:':'公司名称'" prop="corporateName">
              <span v-if="isDetail || isApprove">{{ dialogForm.corporateName }}</span>
              <el-input v-else v-model="dialogForm.corporateName" />
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="联系人:" prop="contactName">
              <span v-if="isDetail || isApprove">{{ dialogForm.contactName }}</span>
              <el-input v-else v-model="dialogForm.contactName" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="电话:" prop="phoneNumber">
              <span v-if="isDetail || isApprove">{{ dialogForm.phoneNumber }}</span>
              <el-input v-else v-model="dialogForm.phoneNumber" />
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="邮箱:" prop="customerEmail">
              <span v-if="isDetail || isApprove">{{ dialogForm.customerEmail }}</span>
              <el-input v-else v-model="dialogForm.customerEmail" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="地址:" prop="corporateAddress">
              <span v-if="isDetail || isApprove">{{ dialogForm.corporateAddress }}</span>
              <el-input v-else v-model="dialogForm.corporateAddress" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider />
        <el-row>
          <el-col :span="10">
            <el-form-item label="是否需要唛头:" porp="markType">
              <span v-if="isDetail || isApprove">{{ dialogForm.markType?'是':'否' }}</span>
              <el-radio-group v-else v-model="dialogForm.markType">
                <el-radio :label="true">
                  是
                </el-radio>
                <el-radio :label="false">
                  否
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="授权邮箱:" prop="authorizationEmail">
              <span v-if="isDetail || isApprove">
                <el-tag v-for="item in currentEamilList" :key="item" class="itemTag" size="small">
                  {{ item }}
                </el-tag></span>
              <div v-else>
                <el-button v-show="emailStatu" type="primary" @click="addEmail">
                  添加邮箱
                </el-button>
                <el-input v-show="!emailStatu" v-model="currentEamil" class="emailInput" @keyup.enter.native="emailBlur" @input="validateEmail" />
                <span v-show="!isEmailValid&&!emailStatu" class="error-message">请输入有效的邮箱地址</span>
                <div v-if="currentEamilArr.length !== 0">
                  <el-tag v-for="item in currentEamilList" :key="item" class="itemTag" size="small" closable @close="handleClose(item)">
                    {{ item }}
                  </el-tag>
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 是否合并关联单号 -->
        <el-row>
          <el-col :span="10">
            <el-form-item label="是否有其它发货单申请合并发货:" porp="markType" class="is-consolidated-shipment-lable-style">
              <span v-if="isDetail || isApprove">
                {{ dialogForm.mergeShip ? '是' : '否' }}
              </span>
              <!-- <el-radio-group v-else v-model="dialogForm.mergeShip">
                <el-radio :label="true">
                  是
                </el-radio>
                <el-radio :label="false">
                  否
                </el-radio>
              </el-radio-group> -->
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="其他发货单申请单号:" prop="mergeNum" class="merge-num-lable-style">
              <el-input v-model.trim="dialogForm.mergeNum" v-restrict-input />
              <!-- <span v-else-if="isApprove||isDetail">
                {{ dialogForm.mergeNum }}
              </span> -->
            </el-form-item>
          </el-col>
        </el-row>
        <div style="margin: 20px 0; font-weight: 800; font-size: 18px;">
          发运信息
        </div>
        <template v-if="isDetail || isApprove">
          <el-row>
            <el-col :span="6">
              <el-form-item label="贸易术语:">
                {{ dialogForm.tradeTerms }}
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="包装要求:">
                {{ dialogForm.packagingRequirements }}
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="货运方式:">
                <!-- 2024年1月8号, 后端返回的 选择项 海运 为空值,后端无法处理 这里做了处理 -->
                {{ dialogForm.modeOfShipping === '' ? '海运' : dialogForm.modeOfShipping }}
              </el-form-item>
            </el-col>
          </el-row>
          <attachment-uploading ref="fileRef" :file-list="fileInfo" :is-upload="false" style="margin-bottom: 10px" />
          <el-row v-if="isDetail">
            <el-col v-if="[1,2,3].includes(showNotes)">
              <el-form-item label="商务发货备注说明:">
                {{ dialogForm.deliverRemarkBusiness }}
              </el-form-item>
            </el-col>
            <el-col v-if="[2,3].includes(showNotes)">
              <el-form-item label="关务发货备注说明:">
                {{ dialogForm.deliverRemark }}
              </el-form-item>
            </el-col>
          </el-row>
        </template>
        <template v-else>
          <el-form-item label="贸易术语:" prop="tradeTerms">
            <el-select v-model="dialogForm.tradeTerms" clearable>
              <el-option v-for="option in tradeTermsSelectList" :key="option.dictValue" :label="option.dictLabel" :value="option.dictValue" />
            </el-select>
          </el-form-item>
          <el-form-item label="包装要求:" prop="packagingRequirements">
            <span>
              <el-select v-model="dialogForm.packagingRequirements" clearable>
                <el-option v-for="option in packingRequirementSelectList" :key="option.dictValue" :label="option.dictLabel" :value="option.dictValue" />
              </el-select>
              <span style="margin-left: 20px">注：选择其他时，线下传递非标申请表</span>
            </span>
          </el-form-item>
          <el-form-item label="货运方式:" prop="modeOfShipping">
            <el-select v-model="dialogForm.modeOfShipping" placeholder="请选择" clearable>
              <el-option v-for="option in shippingMethodSelectList" :key="option.dictValue" :label="option.dictLabel" :value="option.dictValue" />
            </el-select>
          </el-form-item>
          <!-- 销售提效需求,只会在编辑时,修改批次 -->
          <el-form-item label="批次:">
            <el-select
              v-model="dialogForm.batchNumber"
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="item in batchNumberOptionsData"
                :key="item.id"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <attachment-uploading ref="fileRef" :file-list="fileInfo" :is-upload="[1].includes(showNotes)" />
        </template>
        <template v-if="!isDetail">
          <div v-if="[1].includes(showNotes)">
            <div style="margin: 20px 0; font-weight: 800; font-size: 18px;">
              商务发货备注说明
            </div>
            <el-form-item label-width="0">
              <el-input v-model="dialogForm.deliverRemarkBusiness" type="textarea" :rows="5" maxlength="1000" placeholder="请输入内容" show-word-limit />
            </el-form-item>
          </div>
          <div v-if="[2,3].includes(showNotes)">
            <div>
              <div style="margin: 20px 0; font-weight: 800; font-size: 18px;">
                商务发货备注说明
              </div>
              <el-form-item label-width="0">
                {{ dialogForm.deliverRemarkBusiness }}
              </el-form-item>
            </div>
            <div style="margin: 20px 0; font-weight: 800; font-size: 18px;">
              关务发货备注说明
            </div>
            <el-form-item label-width="0">
              <el-input v-model="dialogForm.deliverRemark" type="textarea" :rows="5" maxlength="1000" placeholder="请输入内容" show-word-limit />
            </el-form-item>
          </div>
        </template>
        <template v-if="isApprove">
          <div style="margin: 20px 0; font-weight: 800; font-size: 18px;">
            审批意见
          </div>
          <el-form-item label-width="0" prop="approvalOpinion">
            <el-input v-model="dialogForm.approvalOpinion" type="textarea" :rows="5" maxlength="200" placeholder="请输入内容" show-word-limit />
          </el-form-item>
        </template>
      </el-form>
      <template v-if="isDetail">
        <div style="margin: 20px 0; font-weight: 800; font-size: 18px;">
          历史审批意见
        </div>
        <el-table :data="approveList" style="margin: 10px 0" border>
          <el-table-column align="left" label="审批人" prop="approveUserInfo">
            <template v-slot="{row}">
              {{ row.approveUserInfo }}
            </template>
          </el-table-column>
          <el-table-column align="left" label="审批内容" prop="approveComment" />
          <el-table-column align="left" label="审批时间" prop="approveTime" />
        </el-table>
      </template>
    </div>
    <div>
      <template v-if="isEdit">
        <el-button :loading="isBtnLoading" type="primary" @click="handlerSubmitAndReturnTheList">
          提交并返回列表
        </el-button>
        <el-button :loading="isBtnLoading" type="warning" @click="handlerAbandonApplication">
          废弃申请
        </el-button>
      </template>
      <el-button v-if="isDetail" @click="handlerCancelApplication">
        取消
      </el-button>
      <template v-if="isApprove">
        <el-button :loading="isBtnLoading" type="primary" @click="handleConsent">
          同意
        </el-button>
        <el-button :loading="isBtnLoading" type="warning" @click="handleReject">
          驳回至商务
        </el-button>
        <el-button v-if="this.intelPartialInvoiceInfo.omsBatchNum" :loading="isBtnLoading" type="warning" @click="handleRejectSupply">
          驳回至供应
        </el-button>
      </template>
      <!-- 发送关务邮箱  -->
      <template v-if="isEdit">
        <el-select
          v-model="dialogForm.noticeEmail"
          class="inter-send-customs-email-style"
          placeholder="请选择发送的邮箱"
          clearable
          @change="changeSalesEmaile"
        >
          <el-option
            v-for="item in selectEmailUserName"
            :key="item.dictValue"
            :label="item.dictLabel"
            :value="item.dictValue"
          />
        </el-select>
        <el-checkbox
          v-model="isCheckEmaileNotificationStatus"
          @change="clickEmaileNotificationStatus"
        />
        <span
          class="inter-send-customs-email-tips-style"
        >是否通知审批人</span>
      </template>
    </div>
  </el-dialog>
</template>

<script>
import { DateToStr, MathAdd } from '@/libs/util';
import {
  abandonInvoiceHasBeenApplied,
  getObtainTheShippingDetailsOfTheApplication,
  recomposeObtainTheShippingDetailsOfTheApplication,
  examineAndApprove, // 关务审批
  orderClerkApproval,
  orderClerkAllocated,
  mailboxVerification,
  getIntelPartialId,
  isBGContract
} from '@/API/international';
import { RejectSupply } from '@/API/BatchManagement.js';
import { Message } from 'element-ui';
import { getDictData } from '@/API';
import { mapState } from 'vuex';
import big from 'big.js';
import AttachmentUploading from '@/views/business/components/AttachmentUploading.vue';
import { buildIntlPartialShipmentComplianceRequest, checkIntlExportCompliance } from '@/libs/exportCompliance';
export default {
  name: 'InternationalApplyForDeliveryDialog',
  components: { AttachmentUploading },
  props: {
    /**
     * 是否为详情页 默认false
     */
    isDetail: {
      type: Boolean,
      default: false
    },
    /**
     * 是否可编辑
     */
    isEdit: {
      type: Boolean,
      default: false
    },
    /**
     * 是否审批
     */
    isApprove: {
      type: Boolean,
      default: false
    },

    /**
     *  审批角色名称
     *  customs 关务
     *  orderTaker 订单员
     */

    approveRole: {
      type: String,
      default: ''
    },

    /**
     * 控制弹出框的显示，默认false
     */
    dialogVisibleFromApplyForDelivery: {
      type: Boolean,
      default: false
    },
    /**
     * 当前点击行的数据
     */
    currentClickData: {
      type: Object,
      default: () => ({}),
      require: true
    },
    /**
     * 是否原始订单号
     */
    isOriginOrderNumber: {
      type: Boolean,
      default: false
    },
    /**
     * 显示各角色备注
     * 0: 都不显示
     * 1: 显示商务
     * 2: 显示关务
     * 3: 显示商务、关务
     */
    showNotes: {
      type: Number,
      default: 0
    },
    /**
     * 订单员已审批自动过单，关务，展示分配金额
     */
    isDistriMoney: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      containPhysicalDataList: [], // 包含实物列表数据
      notContainPhysicalDataList: [], // 不包含实物列表数据
      productInfo: [], // 存储原始数据product
      containPhysicalSelectRows: [],
      notCntainPhysicalSelectRows: [],
      emailStatu: true,
      currentEamil: '',
      currentEamilArr: [],
      isEmailValid: true,
      isBGContract: false,
      // 表单
      dialogForm: {
        receiptAddressId: '', // 收货地址
        corporateName: '', // 公司名称
        corporateAddress: '', // 地址
        contactName: '', // 联系人
        phoneNumber: '', // 电话
        customerEmail: '', // 邮箱
        markType: true, // 是否需要唛头
        authorizationEmail: '', // 授权邮箱
        tradeTerms: '', // 贸易术语
        packagingRequirements: '', // 包装要求
        modeOfShipping: '', // 货运方式
        deliverRemark: '', // 发货备注
        deliverRemarkBusiness: '', // 商务发货备注
        approvalOpinion: '', // 审批意见
        mergeShip: false, // 是否有其他发货单申请合并发货
        mergeNum: '', // 其他发货单,申请单号
        batchNumber: '', // 批次号
        noticeEmail: '' // 通知关务邮箱名称
      },
      // 收获地址
      deliveryAddressSelectList: [],
      // 贸易数语
      tradeTermsSelectList: [],
      // 包装要求
      packingRequirementSelectList: [],
      // 货运方式
      shippingMethodSelectList: [],
      dialogVisible: this.dialogVisibleFromApplyForDelivery,
      approveList: [],
      originalData: {}, // 原始数据
      intelPartialInvoiceInfo: {},
      dialogLoading: false,
      // 审批方法配置
      approveMethodsConfig: {
        customs: examineAndApprove,
        orderTaker: orderClerkApproval
      },
      addressInfos: {},
      propertyNumInfos: {},
      isDialogLoading: false,
      allocatedDetail: [], // 分配发货金额
      amountSum: 0, // 主表实际发货总金额
      needAuthorizedMailbox: false, // 是否需要授权邮箱
      isBtnLoading: false,
      // 附件列表
      fileInfo: [],
      isCheckEmaileNotificationStatus: false, // 是否选中了通知邮箱状态
      selectEmailUserName: [], // 发送关务,邮件提醒审批人数据
      batchNumberOptionsData: this.generateOptionsData(), // 批次号生成1~99的函数
      // 分配金额
      distriMoneyList: [],
      // 批次
      batchNum: ''
    };
  },
  computed: {
    ...mapState('pagesTemporary', ['OrderPersionContractListTabActive']),
    // 计算总数量
    totalAllQuantity () {
      let total = 0;
      this.containPhysicalDataList.forEach((item) => {
        total = big(total).plus(item.productNum).toNumber();
      });

      this.notContainPhysicalDataList.forEach((item) => {
        total = big(total).plus(item.productNum).toNumber();
      });
      return total;
    },
    // 实际结算总金额
    totalAllAmountSum () {
      let total = 0;
      this.containPhysicalDataList.forEach((item) => {
        total = big(total).plus(item.amountSum).toNumber();
      });

      this.notContainPhysicalDataList.forEach((item) => {
        total = big(total).plus(item.amountSum).toNumber();
      });
      return total;
    },
    showOrderNumberColumn () {
      const mergedList = [...this.containPhysicalDataList, ...this.notContainPhysicalDataList];
      return mergedList.some(item => Object.prototype.hasOwnProperty.call(item ?? {}, 'orderNumber'));
    },
    headerText () {
      switch (true) {
        case this.isEdit: return '编辑';
        case this.isApprove: return '审核';
        case this.isDetail: return '查看';
        default: return '';
      }
    },
    /**
     * 动态rules根据 类型的不同 返回不同的rules
     */
    rules () {
      let rulesConfig = {
        isEdit: {
          // 收货地址
          receiptAddressId: [
            { required: true, message: '请选择收货地址', trigger: ['blur', 'change'] }
          ],
          // 公司名称
          corporateName: [
            { required: true, message: '请输入公司地址', trigger: ['blur', 'change'] }
          ],
          // 地址
          corporateAddress: [
            { required: true, message: '请输入地址', trigger: ['blur', 'change'] }
          ],
          // 联系人
          contactName: [
            { required: true, message: '请选输入联系人', trigger: ['blur', 'change'] }
          ],
          // 电话
          phoneNumber: [
            { required: true, message: '请输入手机号', trigger: ['blur', 'change'] }
          ],
          // 邮箱
          customerEmail: [
            { type: 'string', required: true, message: '请输入邮箱地址', trigger: ['blur', 'change'] }
          ],
          // 贸易术语
          tradeTerms: [
            { required: true, message: '请选择贸易术语', trigger: ['blur', 'change'] }
          ],
          // 包装要求
          packagingRequirements: [
            { required: true, message: '请选择包装要求', trigger: ['blur', 'change'] }
          ],
          // 授权邮箱
          authorizationEmail: [
            { type: 'string', required: this.needAuthorizedMailbox, message: '请输入邮箱地址', trigger: ['blur', 'change'] }
          ]
          // 其他发货单申请单号
          // mergeNum: [
          //   { type: 'string', required: this.dialogForm.mergeShip, message: '请输入其它发货单申请单号', trigger: ['blur', 'change'] }
          // ]
        },
        isDetail: null,
        // 审批员 校验
        isApprove: {
          approvalOpinion: [
            { required: true, message: '请输入审批意见', trigger: ['change', 'blur'] }
          ]
        }
      };
      switch (true) {
        case this.isEdit: return rulesConfig['isEdit'];
        case this.isApprove: return rulesConfig['isApprove'];
        case this.isDetail: return rulesConfig['isDetail'];
      }
      return false;
    },
    /**
     * 当前应该用的审批方法
     * @returns {*}
     */
    approveMethod () {
      return this.approveMethodsConfig[this.approveRole];
    },
    currentEamilList () {
      return this.currentEamilArr.filter(item => item);
    }
  },
  watch: {
    dialogVisibleFromApplyForDelivery (val) {
      this.dialogVisible = val;
    },
    dialogVisible (val) {
      console.log('va', val, this.isDistriMoney);
      if (val && this.isDistriMoney) {
        this.queryIntelPartialId();
      }
      this.$emit('on-status-dialog', val);
    },
    /**
     * 是否需要授权邮箱
     */
    productInfo: {
      deep: true,
      immediate: true,
      handler () {
        // if (this.approveRole !== 'orderTaker' && this.isEdit) {
        console.log('watch', this.productInfo);
        let materialNumbers = this.productInfo.filter(item => !item.isDelete).map(item => item.materialNumber);
        mailboxVerification(materialNumbers).then(res => {
          let json = res.data;
          if (json.status === '200') {
            this.needAuthorizedMailbox = json.data;
          }
        });
        // eslint-disable-next-line no-unused-expressions
        this.productInfo.length > 0 ? isBGContract({ contractNum: this.productInfo[0].contractNum }).then(res => {
          if (res.data.status === '200') {
            this.isBGContract = res.data.data;
          }
        }) : '';
        // }
      }
    }

  },
  methods: {
    transformationResEmailValue () {
      this.currentEamilArr = this.dialogForm.authorizationEmail.split(',');
    },
    validateEmail () {
      const emailPattern = /^([a-zA-Z0-9]+[._-]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[._-]?)*[a-zA-Z0-9]+(\.[a-zA-Z]{2,})+$/i;
      this.isEmailValid = emailPattern.test(this.currentEamil);
    },
    transformationEmailValue () {
      this.currentEamilArr = this.currentEamilArr.filter(item => item);
      this.dialogForm.authorizationEmail = this.currentEamilArr.join(',');
    },
    addEmail () {
      this.emailStatu = false;
    },
    emailBlur () {
      if (this.currentEamil && this.isEmailValid) {
        this.currentEamilArr.push(this.currentEamil);
        this.currentEamil = '';
        this.transformationEmailValue();
      }
      this.emailStatu = true;
    },
    handleClose (val) {
      this.currentEamilArr.splice(this.currentEamilArr.indexOf(val), 1);
      this.transformationEmailValue();
    },
    getHaveAppliedTableDataListMethods () {
      this.containPhysicalDataList = this.productInfo.filter(item => item.physicalFlag);
      this.notContainPhysicalDataList = this.productInfo.filter(item => !item.physicalFlag);
    },
    DateToStr,
    // 生成批次编码,1~99的范围数据
    generateOptionsData () {
      const data = [];
      for (let i = 1; i <= 99; i++) {
        data.push({
          id: i,
          value: i,
          label: `${i}`
        });
      }
      return data;
    },
    // 选择关务,发送邮箱通知事件
    changeSalesEmaile (val) {
      if (val) {
        this.dialogForm.selectSendEmailNmae = val;
        this.clickEmaileNotificationStatus();
      } else {
        this.clickEmaileNotificationStatus();
      }
    },
    // 发送通知邮箱,勾选状态
    clickEmaileNotificationStatus (val) {
      if (this.dialogForm.selectSendEmailNmae) {
        this.isCheckEmaileNotificationStatus = true;
      } else {
        this.isCheckEmaileNotificationStatus = false;
      }
    },
    /**
     * 删除产品 0默认  1删除
     */
    removeProduct () {
      this.$confirm('确定要删除勾选的产品吗？', '', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let ids = this.containPhysicalSelectRows.map(item => item.id);
        let notIds = this.notCntainPhysicalSelectRows.map(item => item.id);
        let selectId = [...ids, ...notIds];
        if (!selectId.length) return;
        this.productInfo = this.productInfo.filter(item => !selectId.includes(item.id));
        this.getHaveAppliedTableDataListMethods();
      }).catch((e) => {
        console.log(e);
      });
    },
    /**
     * 勾选时把勾选的赋值到selectRows
     * @param rows
     */
    selectionChange (rows) {
      this.containPhysicalSelectRows = rows;
    },
    notSelectionChange (rows) {
      this.notCntainPhysicalSelectRows = rows;
    },
    /**
     * 根据整改交期是否在当前时间+7天 之后去判断是否可勾选删除
     */
    // isCanRemoveProduct (row) {
    //   if (row.index === '小计') {
    //     return false;
    //   }
    //   let productDate = new Date(row.expectationSendTime);
    //   let nowDate = new Date();
    //   let timeDate = (1000 * 60) * 60 * 24 * 7;
    //   if ((nowDate.getTime() + timeDate) < productDate.getTime()) {
    //     return true;
    //   }
    //   return false;
    // },
    /**
     * 提交并返回列表
     */
    handlerSubmitAndReturnTheList () {
      this.$refs.dialogForm.validate(async isPass => {
        /**
         * addUpdate:1新增，2编辑
         */
        if (this.productInfo.length === 0) {
          this.$message.error('分批发货需要至少有一条产品');
          return;
        }
        if (isPass) {
          this.dialogLoading = true;
          // 编辑提交分批发货：提交前出口合规预检
          const invoiceInfo = this.originalData.intelPartialInvoiceInfo || {};
          const complianceDecision = await checkIntlExportCompliance(this,
            buildIntlPartialShipmentComplianceRequest({
              agentName: invoiceInfo.agentName,
              soldCountry: invoiceInfo.overSeasSalesCountry,
              corporateName: this.dialogForm.corporateName,
              corporateAddress: this.dialogForm.corporateAddress,
              deliveryNum: this.currentClickData && this.currentClickData.deliveryNum,
              products: this.productInfo
            }));
          if (!complianceDecision.allowBusiness) {
            this.dialogLoading = false;
            return;
          }
          let params = {
            addUpdate: 2,
            partialInvoiceProducts: [
              ...this.productInfo
            ],
            intelPartialInvoiceInfo: {
              ...this.originalData.intelPartialInvoiceInfo
            },
            partialInvoiceDetail: {
              ...this.originalData.partialInvoiceDetail,
              ...this.dialogForm,
              approvalOpinion: undefined,
              amountSum: this.totalAllAmountSum
            },
            ...([1].includes(this.showNotes) ? { fileInfo: this.$refs.fileRef.getFileList() } : { fileInfo: this.originalData.fileInfo })
          };
          recomposeObtainTheShippingDetailsOfTheApplication(params)
            .then((res) => {
              let json = res.data;
              if (json.status === '200') {
                this.$message.success('提交成功');
                this.dialogVisible = false;
                this.$emit('refresh-table');
              }
              this.dialogLoading = false;
            }).catch(() => {
              this.dialogLoading = false;
            });
        }
      });
    },
    /**
     * 取消申请、详情关闭， 关闭对话框
     */
    handlerCancelApplication () {
      this.dialogVisible = false;
    },
    /**
     * 废弃申请 关闭对话框
     */
    handlerAbandonApplication () {
      this.$confirm(`确认废弃申请发货单(${this.currentClickData.deliveryNum})`)
        .then(_ => {
          this.isDialogLoading = true;
          this.isBtnLoading = true;
          abandonInvoiceHasBeenApplied({ id: this.currentClickData.id }).then((res) => {
            const json = res.data;
            if (json.status === '200') {
              if (json.data) {
                Message.success('废弃成功');
                this.isDialogLoading = false;
                this.$emit('refresh-table');
                this.isBtnLoading = false;
                this.dialogVisible = false;
              } else {
                Message.success('废弃失败');
                this.isDialogLoading = false;
                this.isBtnLoading = false;
                this.dialogVisible = false;
              }
            } else {
              Message.success('废弃失败');
              this.isDialogLoading = false;
              this.isBtnLoading = false;
              this.dialogVisible = false;
            }
          }).catch(() => {
            this.isDialogLoading = false;
            this.isBtnLoading = false;
            this.dialogVisible = false;
          });
        })
        .catch(_ => {});
    },
    /**
     * 计算总计
     */
    getTotal ({ columns, data }) {
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          // 除详情外合计向后移动一列
          if (this.isDetail) {
            sums[index] = '合计';
          } else {
            sums[index + 1] = '合计';
          }
          return;
        }
        /**
         * 去掉小计
         */
        const values = data.map(item => item.index !== '小计' && Number(item[column.property]));
        if (column.property === 'productNum') {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return MathAdd(prev, curr);
            } else {
              return prev;
            }
          }, 0);
        } else if (column.property === 'amountSum') {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return MathAdd(prev, curr);
            } else {
              return prev;
            }
          }, 0).toFixed(2);
          this.amountSum = sums[index];
        } else {
          if (!this.isDetail && index !== 1) {
            sums[index] = '';
          }
        }
      });
      return sums;
    },
    /**
     * 隐藏小计复选框
     */
    setCheckBoxHiddenOrVisible ({ row }) {
      if (row.index === '小计') {
        return 'table-column-hidden';
      }
    },
    /**
     * 获取下拉列表
     */
    getDictDataList () {
      this.dialogLoading = true;
      this.isBtnLoading = true;
      let params = ['trade_term', 'packaging_requirements', 'freight_mode', 'intel_partial_addr_id', 'CUSTOMS_NOTICE'];
      getDictData(params).then(res => {
        let json = res.data;
        if (json.status === '200') {
          json.data.forEach(dictInfo => {
            switch (dictInfo.dictType) {
              case 'trade_term':
                this.tradeTermsSelectList = dictInfo.dictDataVOS;
                break;
              case 'packaging_requirements':
                this.packingRequirementSelectList = dictInfo.dictDataVOS;
                break;
              case 'freight_mode':
                this.shippingMethodSelectList = dictInfo.dictDataVOS;
                break;
              case 'CUSTOMS_NOTICE':
                this.selectEmailUserName = dictInfo.dictDataVOS;
                break;
              case 'intel_partial_addr_id':
                this.deliveryAddressSelectList = dictInfo.dictDataVOS;
                this.addressInfos = dictInfo.dictDataVOS.reduce((p, n) => ({ ...p, [n.dictValue]: n.dictLabel }), {});
                break;
            }
          });
        }
        this.dialogLoading = false;
        this.isBtnLoading = false;
      }).catch(() => {
        this.dialogLoading = false;
        this.isBtnLoading = false;
      });
    },
    /**
     * 请求数据 返回数据格式
     * {
     *  productList{Array} 产品列表
     *  approveList{Array} 审批意见表
     *  intelPartialInvoiceInfo{Object} 主表信息
     *  partialInvoiceDetail{Array}  申请详情表
     * }
     */
    getDetail () {
      /**
       * @type {{id}} 外界传入申请表行数据的id
       */
      this.dialogLoading = true;
      this.isBtnLoading = true;
      let params = {
        id: this.currentClickData.id,
        // ...(this.OrderPersionContractListTabActive === '9' ? { deliveryNum: this.currentClickData.deliveryNum } : {})
        // 如果是原始订单预览则拿取原始订单号，不是则拿订单号
        deliveryNum: this.isOriginOrderNumber ? this.currentClickData.oldDeliveryNum : this.currentClickData.deliveryNum
      };
      getObtainTheShippingDetailsOfTheApplication(params)
        .then(res => {
          this.dialogLoading = true;
          this.isBtnLoading = true;
          let json = res.data;
          if (json.status === '200') {
          // 审批信息列表
            this.approveList = json.data.approveList;
            this.intelPartialInvoiceInfo = json.data.intelPartialInvoiceInfo;
            // 产品列表
            // 产品列表 如是审批并且是订单员 则混入一个存储属性号输入的字段propertyNumInputTemp(原本属性号有值的话，就直接跳过)
            if (this.isApprove && this.approveRole === 'orderTaker') {
              let propertyNumInfos = {};
              json.data.productList.forEach(item => {
                item.propertyNum && (propertyNumInfos[propertyNumInfos.id] = '');
              });
              this.propertyNumInfos = propertyNumInfos;
            }
            // this.productInfo = this.isEdit ? json.data.productList.map(item => ({ ...item, delete: 0 })) : json.data.productList;
            this.productInfo = json.data.productList.filter(Boolean);
            // 申请发货单详情
            for (let key in this.dialogForm) {
              // 三种类型不用赋值 null undefined ''
              let typeArray = [null, undefined, ''];
              if (!typeArray.includes(json.data.partialInvoiceDetail[key])) {
                this.dialogForm[key] = json.data.partialInvoiceDetail[key];
              }
            }
            this.transformationResEmailValue();
            this.fileInfo = json.data.fileInfo;
            // 存储本次请求数据
            this.originalData = json.data;
            this.dialogLoading = false;
            this.isBtnLoading = false;
            // 批次
            this.batchNum = json.data.partialInvoiceDetail.batchNum;
            this.getHaveAppliedTableDataListMethods();
          }
        })
        .catch(() => {
          this.dialogLoading = false;
          this.isBtnLoading = false;
        });
    },
    /**
     * 打开弹窗请求下拉数据、请求详情数据并回显
     */
    open () {
      this.getDictDataList();
      this.approveRole === 'orderTaker' && this.isApprove && this.getAllocatedDetail();
      this.getDetail();
    },
    /**
     * 关闭时 清空数据
     */
    clearAll () {
      this.$refs.dialogForm.resetFields();
      this.dialogForm.modeOfShipping = '';
      this.originalData = {};
      this.selectRows = [];
      this.approveList = [];
      this.productInfo = [];
      this.propertyNumInfos = {};
      this.intelPartialInvoiceInfo = {};
      this.deliveryAddressSelectList = [];
      this.tradeTermsSelectList = [];
      this.packingRequirementSelectList = [];
      this.shippingMethodSelectList = [];
      this.allocatedDetail = [];
      this.amountSum = 0;
      this.dialogLoading = false;
      this.isBtnLoading = false;
      this.isBGContract = false;
      this.dialogForm.deliverRemark = '';
      this.dialogForm.deliverRemarkBusiness = '';
    },
    /**
     * 审批同意
     * -1 废弃
     * 0 驳回
     * 1 召回
     * 2 同意
     * 3 撤回（订单员）
     */
    handleConsent () {
      let isMinus = false; // 订单员审批时使用 一般情况下都为false 只有当订单员审批时才会变化
      if (this.approveRole === 'orderTaker' && this.isApprove) {
        isMinus = this.allocatedDetail.some(item => item.amountDifference < 0);
      }
      this.$refs.dialogForm.validate((isPass) => {
        if (isPass) {
          this.isDialogLoading = true;
          this.isBtnLoading = true;
          let params = {};
          if (this.approveRole === 'customs') {
            params = {
              approveType: 2, // 审批类型 -1 废弃 0 驳回 1 召回 2 同意
              approvalComments: this.dialogForm.approvalOpinion, // 审批意见
              remarks: this.dialogForm.deliverRemark, // 发货备注
              id: this.intelPartialInvoiceInfo.id, // 主发货单表Id
              mergeNum: this.dialogForm.mergeNum
            };
          }
          if (this.approveRole === 'orderTaker') {
            params = {
              id: this.currentClickData.id,
              remarks: this.dialogForm.deliverRemark,
              approvalComments: this.dialogForm.approvalOpinion,
              type: 3,
              approveType: 2,
              partialInvoiceProducts: this.productInfo.map(item => {
                return this.propertyNumInfos[item.id] ? { ...item, propertyNum: this.propertyNumInfos[item.id] } : item;
              }) };
          }
          /**
           * 这里存在两段相同的代码可以考虑优化
           */
          if (isMinus) {
            this.$confirm('存在合同已分配金额不足，确认审批同意吗？').then(() => {
              this.approveMethod(params).then(res => {
                if (res.data.status === '200') {
                  this.$message.success(res.data.err);
                  this.dialogVisible = false;
                  this.isBtnLoading = false;
                  this.isDialogLoading = false;
                  this.$emit('refresh-table');
                } else {
                  this.isBtnLoading = false;
                  this.isDialogLoading = false;
                }
              }).catch(() => {
                this.isBtnLoading = false;
                this.isDialogLoading = false;
              });
            }).catch(() => {
              this.isBtnLoading = false;
              this.isDialogLoading = false;
            });
          } else {
            this.approveMethod(params).then(res => {
              if (res.data.status === '200') {
                this.$message.success(res.data.err);
                this.dialogVisible = false;
                this.isBtnLoading = false;
                this.isDialogLoading = false;
                this.$emit('refresh-table');
              } else {
                this.isBtnLoading = false;
                this.isDialogLoading = false;
              }
            }).catch(() => {
              this.isBtnLoading = false;
              this.isDialogLoading = false;
            });
          }
        }
      });
    },
    /**
     * 审批驳回
     */
    handleReject () {
      this.$refs.dialogForm.validate(isPass => {
        if (isPass) {
          this.isDialogLoading = true;
          this.isBtnLoading = true;
          let params = {};
          if (this.approveRole === 'customs') {
            params = {
              approveType: 0, // 审批类型 -1 废弃 0 驳回 1 召回 2 同意
              approvalComments: this.dialogForm.approvalOpinion, // 审批意见
              remarks: this.dialogForm.deliverRemark, // 发货备注
              id: this.intelPartialInvoiceInfo.id, // 主发货单表Id
              mergeNum: this.dialogForm.mergeNum

            };
          }

          if (this.approveRole === 'orderTaker') {
            params = {
              approveType: 0, // 审批类型 -1 废弃 0 驳回 1 召回 2 同意
              approvalComments: this.dialogForm.approvalOpinion, // 审批意见
              remarks: this.dialogForm.deliverRemark, // 发货备注
              id: this.intelPartialInvoiceInfo.id // 主发货单表Id
            };
          }
          this.approveMethod(params).then(res => {
            if (res.data.status === '200') {
              this.$message.success(res.data.err);
              this.dialogVisible = false;
              this.isBtnLoading = false;
              this.isDialogLoading = false;
              this.$emit('refresh-table');
            }
          }).catch(() => {
            this.dialogVisible = false;
          });
          this.isDialogLoading = false;
        }
      });
    },
    handleRejectSupply () {
      this.$refs.dialogForm.validate(isPass => {
        if (isPass) {
          this.isDialogLoading = true;
          this.isBtnLoading = true;
          let params = {};
          if (this.approveRole === 'customs') {
            params = {
              approveType: 0, // 审批类型 -1 废弃 0 驳回 1 召回 2 同意
              approvalComments: this.dialogForm.approvalOpinion, // 审批意见
              remarks: this.dialogForm.deliverRemark, // 发货备注
              id: this.intelPartialInvoiceInfo.id, // 主发货单表Id
              mergeNum: this.dialogForm.mergeNum,
              type: 2
            };
          }

          if (this.approveRole === 'orderTaker') {
            params = {
              approveType: 0, // 审批类型 -1 废弃 0 驳回 1 召回 2 同意
              approvalComments: this.dialogForm.approvalOpinion, // 审批意见
              remarks: this.dialogForm.deliverRemark, // 发货备注
              id: this.intelPartialInvoiceInfo.id, // 主发货单表Id
              type: 3
            };
          }
          RejectSupply(params).then(res => {
            if (res.data.status === '200') {
              this.$message.success(res.data.err);
              this.dialogVisible = false;
              this.isBtnLoading = false;
              this.isDialogLoading = false;
              this.$emit('refresh-table');
            }
          }).catch(() => {
            this.dialogVisible = false;
          });
          this.isDialogLoading = false;
        }
      });
    },
    getAllocatedDetail () {
      orderClerkAllocated(this.currentClickData.id).then(res => {
        let json = res.data;
        if (json.status) {
          this.allocatedDetail = json.data;
        }
      });
    },

    // 国际已审批，谢东过单，分配金额
    queryIntelPartialId () {
      getIntelPartialId({ intelPartialId: this.currentClickData.id }).then(res => {
        let { status, data } = res.data;
        if (status === '200') {
          this.distriMoneyList = data;
        }
      });
    }
  }
  // mounted () {
  //   this.getHaveAppliedTableDataListMethods();
  // }
};
</script>

<style scoped lang="scss">
.contain-physical-title-style{
  margin-top: 0;
  font-size: 17px;
}
.not-contain-physical-title-style{
  font-size: 17px;
}
.summary-row{
  display: flex;
  margin-top: 20px;
   table {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
    background-color: #f5f7fa;
    border: 1px solid #ebeef5;
  }

  th,
  td {
    padding: 16px;
    text-align: left;
    border-bottom: 1px solid #ebeef5;
    font-size: 12px;
    line-height: 18px;
  }
  th,
  td:nth-child(1) {
    width: 11%;
  }
 th,
  td:nth-child(2) {
    width: 50%;
    text-align: right;
  }
 th,
  td:nth-child(3) {
   margin-left: 5%;
  }

  th {
    background-color: #f5f7fa;
    font-weight: bold;
  }

  /* 模仿 el-table 的合计行样式 */
  tfoot tr {
    display: flex;
    align-items: center;
    justify-items: center;
    font-weight: bold;
  }

  /* 调整合计行内文字样式 */
  tfoot td {
    text-align: left;
  }

  /* 调整合计行内第一列空白单元格样式 */
  tfoot td:first-child {
    padding:  16px;
    text-align: center;
  }
}
 :deep(.el-divider--horizontal) {
  margin: 10px;
}
.addressSelect{
  width: 650px;
}
:deep(.table-column-hidden .el-checkbox__input){
  display: none
}
.is-consolidated-shipment-lable-style{
  :deep(.el-form-item__label) {
     width: 200px !important;
  }
}
:deep(.el-table__footer-wrapper tbody td.el-table__cell){
  font-weight: 700;
}
.merge-num-lable-style{
  :deep(.el-form-item__label) {
     width: 140px !important;
  }
  :deep(.el-form-item__content) {
    margin-left: 145px !important;
  }
}
.inter-send-customs-email-style{
  width: 350px;
  margin: 0px 20px 0px 20px;
}
.inter-send-customs-email-tips-style{
  margin-left: 10px;
}
.el-tag + .el-tag {
    margin-left: 10px;
  }
.addressSelect{
  width: 650px;
}
.error-message {
  color: red;
  font-size: 12px;
}
</style>
